import { DataProxy } from '@apollo/client';
import { FetchResult } from 'apollo-link';

import { showSnackbar, ShowSnackbarAction } from '../../../actions/showSnackbar';
import { client } from '../../../async/utils/client';
import {
  GetPlexOverviewQuery,
  GetPlexOverviewQueryVariables,
  PlexSnackbarFragment,
  SubscribeToPlexMutation,
  useLeavePlexMutation,
  useSubscribeToPlexMutation,
} from '../../../graphql/gen/types';
import { GET_PLEX_OVERVIEW_QUERY } from '../../../graphql/queries/GetPlexOverview';
import { prependPlexToUserPlexesCache } from '../../../graphql/updates/prependPlexToUserPlexesCache';
import { useDispatch } from '../../../redux';

export function useSubscribeToPlex(): {
  subscribeLoading: boolean;
  leaveLoading: boolean;
  setSnackbar: (plex: PlexSnackbarFragment, visible: boolean, isSubscribed: boolean) => ShowSnackbarAction;
  onSubscribeClick: (plex: PlexSnackbarFragment) => Promise<void>;
  onLeaveClick: (plex: PlexSnackbarFragment) => Promise<void>;
} {
  const dispatch = useDispatch();
  // TODO handle subscribeError
  const [subscribeToPlex, { loading: subscribeLoading }] = useSubscribeToPlexMutation();
  // TODO handle unsubscribeError
  const [leavePlex, { loading: unsubscribeLoading }] = useLeavePlexMutation();
  const setSnackbar = (plex: PlexSnackbarFragment, visible: boolean, isSubscribed: boolean): ShowSnackbarAction => {
    return dispatch(showSnackbar({ plex, visible, isSubscribed }));
  };

  const onSubscribeClick = async (plex: PlexSnackbarFragment): Promise<void> => {
    setSnackbar(plex, false, false);
    await subscribeToPlex({
      variables: { plexId: plex.id },
      update: async (proxy: DataProxy, { data }: FetchResult<SubscribeToPlexMutation>): Promise<void> => {
        const plexData = await client.query<GetPlexOverviewQuery, GetPlexOverviewQueryVariables>({
          query: GET_PLEX_OVERVIEW_QUERY,
          variables: { plexId: plex.id },
        });
        if (data?.subscribeToPlex != null && plexData.data?.loggedIn?.plexById) {
          prependPlexToUserPlexesCache(proxy, {
            plex: plexData.data?.loggedIn?.plexById,
          });
        }
      },
    });
    setSnackbar(plex, true, true);
  };

  const onLeaveClick = async (plex: PlexSnackbarFragment): Promise<void> => {
    setSnackbar(plex, false, true);
    await leavePlex({ variables: { plexId: plex.id } });
    setSnackbar(plex, true, false);
  };
  return { subscribeLoading, leaveLoading: unsubscribeLoading, setSnackbar, onSubscribeClick, onLeaveClick };
}
